import angular from 'angular';

// Used in both the styleguide and angular tests.

module.exports = angular.module('market.mocks', [
  require('./listing')
])
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/mocks/index.js
 **/